function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M70,42l-4.06-5.16,1.78-6.32-5.73-3.21-.77-6.52-6.52-.77-3.21-5.73-6.32,1.78-5.16-4.06-5.16,4.06-6.32-1.78-3.21,5.73-6.52.77-.77,6.52-5.73,3.21,1.78,6.32-4.06,5.16,4.06,5.16-1.78,6.32,5.73,3.21.77,6.52,6.52.77,3.21,5.73,6.32-1.78,5.16,4.06,5.16-4.06,6.32,1.78,3.21-5.73,6.52-.77.77-6.52,5.73-3.21-1.78-6.32,4.06-5.16ZM37.35,55.79l-11.37-13.08,6.04-5.25,5.21,5.99,11.7-14.02,6.14,5.13-17.72,21.23Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/Editors-active.b0f47913.svg";
export { SvgComponent as ReactComponent };